function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { addYears, isAfter, isSameDay, startOfDay } from 'date-fns';
import Decimal from 'decimal.js';
import { compact } from 'lodash-es';
import { OneTimeInStagesModel, StagesTerms, StagesValueType } from "../models/OneTimeInStagesModel";
import { RecurrencePeriodTypes } from "../models/service-billing";
import { ServiceCostType } from "../models/service-cost";
import { fromDateStampObject } from "../models/time";
import { BillingTriggerType } from "../types/api.model";
import { utils } from "../utils";
export const billingTriggersTextsPath = 'billing.triggers';
export const billingStagesTextsPath = 'billing.stages';
export const billingCreditsTextsPath = 'billing.credits';
export const billingInitiationTextsPath = 'billing.initiation';
export function makeInvoiceDateInfo(invoiceDraftDates, selectedDate) {
  if (!invoiceDraftDates.dates().length) {
    throw new Error('futureInvoicesDates.length is 0');
  }
  const actualSelectedDate = selectedDate || invoiceDraftDates.dates()[0];
  return {
    invoiceDraftDates,
    selectedDate: actualSelectedDate,
    isUpcomingSelected: isSameDay(actualSelectedDate, invoiceDraftDates.dates()[0])
  };
}
export function getCreditsWarning(totalCredits, t) {
  if (totalCredits.gt(0)) return {
    text: t.warning({
      amount: utils.formatDollarAmount(totalCredits)
    })
  };
  return null;
}
export const getMaxFutureInvoiceDate = now => addYears(startOfDay(now), 1);

// TODO(ahuvi): try to remove oneTimeInStages - we already merged IN_STAGES_OCCURENCE so it should be safe to do so(?)

export function isFutureEffectiveDate() {
  let effectiveDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  let now = arguments.length > 1 ? arguments[1] : undefined;
  const normalizedEffectiveDate = effectiveDate && (effectiveDate instanceof Date ? effectiveDate : fromDateStampObject(effectiveDate));
  return !!(normalizedEffectiveDate && now && isAfter(startOfDay(normalizedEffectiveDate), startOfDay(now)));
}
export function serviceBillingTriggerOptions(_ref) {
  let {
    t,
    withEffectiveDate,
    recurrencePeriod,
    pricingType,
    billingTrigger,
    isFromAgreement,
    isExistingService,
    featureFlags
  } = _ref;
  const {
    YEARLY_AUTOMATIC_SERVICE,
    BILLING_OCCURRENCE_INLINE_SELECT_SERVICE_INSTANCE
  } = featureFlags;
  const isOneTime = !recurrencePeriod;
  const isYearly = recurrencePeriod === RecurrencePeriodTypes.Yearly;
  const isVariablePrice = pricingType === ServiceCostType.Variable;
  const isFixedPrice = pricingType === ServiceCostType.Fixed;
  const isRangePrice = pricingType === ServiceCostType.Range;
  const isOneTimeManual = !recurrencePeriod && billingTrigger === BillingTriggerType.OneTimeManual;
  const isAmendment = isExistingService && isFromAgreement;
  const isEffectiveDateInFuture = isFutureEffectiveDate(withEffectiveDate === null || withEffectiveDate === void 0 ? void 0 : withEffectiveDate.effectiveDate, withEffectiveDate === null || withEffectiveDate === void 0 ? void 0 : withEffectiveDate.now);
  const isDisabledForOngoingYearly = !isOneTime && isYearly && !YEARLY_AUTOMATIC_SERVICE;
  const getBilledEffectiveDateTexts = () => {
    if (isEffectiveDateInFuture) {
      return {
        text: t.automatic.onEffectiveDate.text(),
        subtext: t.automatic.onEffectiveDate.subtext()
      };
    }
    if (isFromAgreement) {
      return {
        text: t.automatic.immediately.text(),
        subtext: t.automatic.immediately.subtext()
      };
    }
    return {
      text: t.automatic.onProposalAcceptance.text(),
      subtext: t.automatic.onProposalAcceptance.subtext()
    };
  };
  return compact([isFixedPrice && isOneTime && !(isAmendment && isOneTimeManual) && _objectSpread({
    value: 'approval'
  }, getBilledEffectiveDateTexts()), !isVariablePrice && !isRangePrice && !isOneTime && (YEARLY_AUTOMATIC_SERVICE || !isYearly || BILLING_OCCURRENCE_INLINE_SELECT_SERVICE_INSTANCE) && {
    disabled: isDisabledForOngoingYearly,
    disabledTooltip: isDisabledForOngoingYearly ? t.tooltips.yearlyServicesManualOnly() : undefined,
    value: 'ongoing',
    text: t.automatic.onSchedule.text(),
    subtext: t.automatic.onSchedule.subtext()
  }, isFixedPrice && {
    value: 'manualFixed',
    text: t.manual.fixed.text(),
    subtext: t.manual.fixed.subtext()
  }, !isFixedPrice && {
    value: 'manualVariable',
    text: t.manual.variable.text(),
    subtext: t.manual.variable.subtext()
  }]);
}
export const stagesTermsTextMap = t => ({
  [StagesTerms.AutoFirst]: t.terms.autoFirst.text(),
  [StagesTerms.AllManual]: t.terms.allManual.text()
});
export function serviceBillingStagesTermsOptions(_ref2) {
  let {
    t,
    now,
    agreementEffectiveDate,
    isFreshlyAddedToApprovedAgreement
  } = _ref2;
  const autoInvoiceIssued = isFreshlyAddedToApprovedAgreement ? t.invoiceIssuedTiming.onAmendmentsSaved() : isFutureEffectiveDate(agreementEffectiveDate, now) ? t.invoiceIssuedTiming.onEffectiveDate() : t.invoiceIssuedTiming.onAgreementApproval();
  return [{
    value: StagesTerms.AutoFirst,
    text: t.terms.autoFirst.text(),
    subtext: t.terms.autoFirst.subtext({
      autoInvoiceIssued
    })
  }, {
    value: StagesTerms.AllManual,
    text: t.terms.allManual.text(),
    subtext: t.terms.allManual.subtext()
  }];
}
export const makeInitialOneTimeInStages = () => OneTimeInStagesModel.make({
  valueType: StagesValueType.Percent,
  terms: StagesTerms.AutoFirst,
  stages: [OneTimeInStagesModel.makeStage(1, new Decimal(50)), OneTimeInStagesModel.makeStage(2, new Decimal(50))]
});
export function hasYearlyAutomaticBillingError(service, featureFlags) {
  const {
    YEARLY_AUTOMATIC_SERVICE
  } = featureFlags;
  const isYearly = service.billing.recurrencePeriod === RecurrencePeriodTypes.Yearly;
  const isAutomatic = service.billing.trigger === BillingTriggerType.Ongoing || service.billing.trigger === BillingTriggerType.OnApproval;
  return isYearly && !YEARLY_AUTOMATIC_SERVICE && isAutomatic;
}